module.exports = __webpack_public_path__ + "static/media/CTLA_4-135w.219dfac1.webp";